//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "OnlineDoc",
  components: {},
  data: function data() {
    return {};
  },
  created: function created() {},
  computed: {},
  methods: {
    omsClick: function omsClick() {
      // this.$router.push({ path:'http://192.168.9.1:8202/doc.html'})
      window.location.href = "http://192.168.9.1:8202/doc.html";
    }
  }
};